import {
    SET_RESUMO_UPLOAD,
    LOADING_RESUMO_UPLOAD,
    ERROR_RESUMO_UPLOAD,
    HANDLE_CHANGE_CHECK_BOX1,
    HANDLE_CHANGE_CHECK_BOX2
} from './types';

const initialState = {
    setResumoUpload: null,
    loadingResumoUpload: false,
    errorResumoUpload: null,
    resumo_check1: false,
    resumo_check2: false
}

export default function resumoReducer(state = initialState, action) {
    switch (action.type) {

        case SET_RESUMO_UPLOAD:
            return { ...state, setResumoUpload: action.payload }

        case LOADING_RESUMO_UPLOAD:
            return { ...state, loadingResumoUpload: action.payload }

        case ERROR_RESUMO_UPLOAD:
            return { ...state, errorResumoUpload: action.payload }

        case HANDLE_CHANGE_CHECK_BOX1:
            return { ...state, resumo_check1: action.payload }

        case HANDLE_CHANGE_CHECK_BOX2:
                return { ...state, resumo_check2: action.payload }
        
        default:
            return state
    }
}